/* eslint-disable react/no-array-index-key */

import logo from 'assets/header-prevencor-xx.png';
import AssinaturaEletronica from 'components/core/AssinaturaEletronica';
import LaudoActionButtons from 'components/laudos/LaudoActionButtons';
import { Card, Col, Form } from 'react-bootstrap';
import { useSelector } from 'react-redux';

export default function Fetal() {
  const { fetal } = useSelector((state) => state.fetal);
  const fetalPac = fetal[0];

  return (
    <Card>
      <Card.Header className="text-center">
        <img
          src={logo}
          alt="Prevencor"
          style={{ display: 'block', maxWidth: '100%', margin: '0 auto 8px' }}
        />
        <Card.Title>LAUDO DE ECO FETAL</Card.Title>
      </Card.Header>

      <Card.Body>
        <Form noValidate>
          <strong className="mr-auto">Nome do Paciente: </strong>
          {`${fetalPac.CODPAC} - ${fetalPac.NOMEPAC}`}
          <br />
          <strong className="mr-auto">Data de Nasc: </strong>
          {`${fetalPac.dataNasc}`}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <strong className="mr-auto">Sexo: </strong>
          {`${fetalPac.SEXOPAC}`}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <strong className="mr-auto">Idade: </strong>
          {`${fetalPac.idadePAC} anos`}
          <br />
          <strong className="mr-auto">Convênio: </strong>
          {fetalPac.SIGLACONV}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <strong className="mr-auto">Código: </strong>
          {fetalPac.CODFETAL}&nbsp;&nbsp;&nbsp;
          <strong className="mr-auto">Data do Laudo: </strong>
          {fetalPac.dataFetal}
          <br />
          <strong className="mr-auto">Médico que Realizou: Dr. </strong>
          {`${fetalPac.Realizou}`}
          <br />
          <strong className="mr-auto">Médico que Solicitou: Dr. </strong>
          {`${fetalPac.Solicitou}`}
          <hr />
          <Form.Row>
            <Col sm>
              <Form.Group size="sm" controlId="obs">
                <div className="row">
                  <div className="col-12">
                    {fetalPac.DESCRICAO.split('\n').map((item, i) => (
                      <div key={i}>{item}</div>
                    ))}
                  </div>
                </div>
              </Form.Group>
            </Col>
          </Form.Row>
          <div className="text-center no-print mb-2">
            <LaudoActionButtons
              actions={[
                {
                  key: 'timbrado',
                  label: 'Timbrado',
                  onClick: () => window.print(),
                },
              ]}
            />
          </div>
          <AssinaturaEletronica nome={fetalPac.Realizou} data={fetalPac} showPrintButton={false} />
        </Form>
      </Card.Body>
    </Card>
  );
}
